export default __webpack_public_path__ + "static/media/promo-3.5ac03ea0.png";